import React from "react";


export default function About() {
    return (
        <div className="content-wrapper about">
            <div className="about__image image-wrapper">
                <img
                    src="https://res2.weblium.site/res/5fed3c09cf52350021e8c7d0/5ff946c93176ca00217e96bb_optimized_1396?nowebp"
                    alt="img"
                />
            </div>
            <div className="about__article mb-sub">
                <div>
                    In the modern world, our health is regularly exposed to all sorts of stresses. Poor food,
                    untimely nutrition, inadequate sleep - all of this negatively affects our health. Also, do
                    not forget about bad ecology, constant stress at work, etc. All this leads to the fact
                    that we get sick more often, and the systems of our body do not work as they should.
                    Therefore, we can notice a deterioration in the condition of hair, skin, nails, teeth.
                    Your health should be maintained, and dietary supplements and vitamins will help you with
                    this.{" "}
                </div>
                <div>
                    Complexes of natural ingredients will help you maintain your health and improve your
                    well-being. Our company has been working in the market of dietary supplements and vitamins
                    since 1997. It all started with a small company that had just one laboratory. We are now
                    one of the largest manufacturers and sellers of dietary and health supplements in the
                    United States. Our products are sold in 48 states, not to mention the online store
                    available to customers from all over the world.{" "}
                </div>
            </div>
        </div>
    );
}
